<template functionnal>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <circle id="red" fill="#DD0000" cx="256" cy="256" r="252" />
    <path
      id="black"
      fill="#000000"
      d="M 256,0 A 256,256 0 0 0 16,167 H 496 A 256,256 0 0 0 256,0 Z"
      style="fill-opacity: 1"
    />
    <path
      id="gold"
      fill="#FFCC00"
      d="M 256,512 A 256,256 0 0 0 496,345 H 16 a 256,256 0 0 0 240,167 z"
      style="fill-opacity: 1"
      clip-path="none"
    />
  </svg>
</template>
